// src/components/admin/TemasNivel.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import backgroundImage from "../../assets/img/fondoSiete.png";
import HeaderAdmin from "../header/HeaderAdmin";
import Swal from "sweetalert2";
import basura from "../../assets/img/basura.png";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const TemasNivel = () => {
  const { temaId } = useParams();
  const navigate = useNavigate();
  const [tema, setTema] = useState(null);
  const [preguntas, setPreguntas] = useState([]);
  const [error, setError] = useState("");

  // --- estado multimedia (3 slots) ---
  const [contenidos, setContenidos] = useState([]); // [{slot, url, tipo}]
  const [files, setFiles] = useState({ 1: null, 2: null, 3: null });
  const [showMultimedia, setShowMultimedia] = useState(false);
  const [previewSlot, setPreviewSlot] = useState(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        // Preguntas del tema
        const respPreguntas = await axios.get(
          `${API_BASE_URL}/api/preguntas/tema/${temaId}`,
          headers
        );
        setPreguntas(respPreguntas.data);

        // (Opcional) Datos del tema
        try {
          const respTema = await axios.get(
            `${API_BASE_URL}/api/temas/${temaId}`,
            headers
          );
          setTema(respTema.data);
        } catch {
          /* no-op */
        }

        // Multimedia (los 3 slots)
        await cargarMultimediaTema();
      } catch (err) {
        console.error("Error cargando datos:", err);
        setError("Error al cargar los datos del tema");
      }
    };

    if (temaId) cargarDatos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [temaId]);

  // --- helpers multimedia ---
  const detectarTipo = (url = "") => {
    const clean = (url || "").split("?")[0];
    const ext = (clean.split(".").pop() || "").toLowerCase();
    const IMG = ["jpg", "jpeg", "png", "gif", "webp"];
    const VID = ["mp4", "webm", "mov", "m4v", "avi"];
    if (IMG.includes(ext)) return "image";
    if (VID.includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    return "url";
  };

  const cacheBust = (url = "") =>
    url ? `${url}${url.includes("?") ? "&" : "?"}t=${Date.now()}` : url;

  const cargarMultimediaTema = async () => {
    try {
      const headers = { headers: { Authorization: `Bearer ${token}` } };
      const resp = await axios.get(
        `${API_BASE_URL}/api/temas/contenido-multimedia/${temaId}`,
        headers
      );

      const arr = Array.isArray(resp?.data?.contenidos)
        ? resp.data.contenidos
        : resp?.data?.url
        ? [{ slot: 1, url: resp.data.url, tipo: detectarTipo(resp.data.url) }]
        : [];

      // agregamos cache-bust solo para visualización
      const withBust = arr.map((c) => ({
        ...c,
        url: cacheBust(c.url),
        tipo: c.tipo || detectarTipo(c.url),
      }));

      setContenidos(withBust);
    } catch (err) {
      console.error("Error cargando multimedia del tema:", err);
      setContenidos([]);
    }
  };

  const ALLOWED_MIME = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "video/mp4",
    "video/webm",
    "video/quicktime",
    "video/x-m4v",
    "video/x-msvideo",
    "application/pdf",
  ];

  const handleFileChange = (slot, e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!ALLOWED_MIME.includes(f.type)) {
      setError("Tipo de archivo no permitido. Sube imagen, video o PDF.");
      return;
    }
    setError("");
    setFiles((prev) => ({ ...prev, [slot]: f }));
  };

  const handleUpload = async (slot) => {
    const file = files[slot];
    if (!file) {
      setError("Por favor, selecciona un archivo primero.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("contenido_multimedia", file);

      await axios.put(
        `${API_BASE_URL}/api/temas/${temaId}/contenido-multimedia?slot=${slot}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setFiles((prev) => ({ ...prev, [slot]: null }));
      await cargarMultimediaTema();
      Swal.fire("Listo", `Contenido del slot ${slot} actualizado`, "success");
    } catch (err) {
      console.error("Error al subir el archivo:", err);
      setError("Error al subir el archivo. Intenta de nuevo.");
    }
  };

  const handleDeleteSlot = async (slot) => {
    const result = await Swal.fire({
      title: `¿Eliminar contenido del slot ${slot}?`,
      text: "No podrás revertir esto.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#99a3a4",
      confirmButtonText: "Eliminar",
    });
    if (!result.isConfirmed) return;

    try {
      await axios.delete(
        `${API_BASE_URL}/api/temas/${temaId}/contenido-multimedia?slot=${slot}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await cargarMultimediaTema();
      Swal.fire(
        "Eliminado",
        `Contenido del slot ${slot} eliminado.`,
        "success"
      );
    } catch (err) {
      console.error("Error al eliminar contenido del slot:", err);
      setError("Error al eliminar el contenido. Intenta de nuevo.");
    }
  };

  // --- UI de previsualización rápida por tipo ---
  const SmallPreview = ({ url, tipo }) => {
    if (!url) return <div className="text-gray-500">Vacío</div>;
    if (tipo === "image")
      return (
        <img
          src={url}
          alt="Preview"
          className="w-full h-40 object-contain bg-gray-50 rounded"
        />
      );
    if (tipo === "video")
      return (
        <video
          src={url}
          className="w-full h-40 object-contain bg-gray-50 rounded"
          muted
        />
      );
    if (tipo === "pdf")
      return (
        <div className="w-full h-40 bg-gray-50 rounded flex items-center justify-center">
          <span className="text-gray-600 font-medium">PDF</span>
        </div>
      );
    return (
      <div className="w-full h-40 bg-gray-50 rounded flex items-center justify-center">
        <span className="text-gray-600 font-medium">Enlace</span>
      </div>
    );
  };

  // Modal multimedia (ampliado)
  const renderMultimediaModal = () => {
    if (!showMultimedia) return null;
    const content = contenidos.find((c) => c.slot === previewSlot);

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
          <div className="flex justify-between items-center p-4 border-b">
            <h3 className="text-xl font-bold">
              Contenido del tema (slot {previewSlot})
            </h3>
            <button
              onClick={() => setShowMultimedia(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <div className="flex-grow overflow-auto p-4">
            {content?.url ? (
              content.tipo === "image" ? (
                <img
                  src={content.url}
                  alt="Contenido multimedia"
                  className="max-w-full max-h-[65vh] mx-auto object-contain"
                />
              ) : content.tipo === "video" ? (
                <video
                  src={content.url}
                  controls
                  className="max-w-full max-h-[65vh] mx-auto"
                />
              ) : content.tipo === "pdf" ? (
                <div className="max-w-full mx-auto">
                  <iframe
                    src={content.url}
                    title="Documento PDF"
                    className="w-full"
                    style={{ height: "70vh", border: "none" }}
                  />
                  <div className="mt-2 text-center">
                    <a
                      href={content.url}
                      target="_blank"
                      rel="noreferrer"
                      className="underline"
                    >
                      Abrir PDF en nueva pestaña
                    </a>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-600">
                  Tipo de contenido no soportado.
                </p>
              )
            ) : (
              <p className="text-center text-gray-600">
                No hay contenido en este slot.
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Card para cada slot (1..3)
  const SlotCard = ({ slot }) => {
    const content = contenidos.find((c) => c.slot === slot);
    const fileSelected = files[slot];

    return (
      <div className="bg-white rounded-lg p-4 shadow border">
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-semibold">Slot {slot}</h4>
          <div className="flex gap-2">
            <button
              onClick={() => {
                setPreviewSlot(slot);
                setShowMultimedia(true);
              }}
              className="px-3 py-1 rounded border text-green-700 border-green-700 hover:bg-green-50"
            >
              Ver
            </button>
            <button
              onClick={() => handleDeleteSlot(slot)}
              disabled={!content}
              className={`px-3 py-1 rounded ${
                content
                  ? "bg-red-500 hover:bg-red-600 text-white"
                  : "bg-gray-200 text-gray-500 cursor-not-allowed"
              }`}
              title={content ? "Eliminar contenido" : "No hay contenido"}
            >
              Eliminar
            </button>
          </div>
        </div>

        <div className="mb-3">
          <SmallPreview url={content?.url} tipo={content?.tipo} />
        </div>

        <div className="space-y-2">
          <input
            type="file"
            onChange={(e) => handleFileChange(slot, e)}
            accept="image/*,video/*,application/pdf"
            className="w-full"
          />
          {fileSelected && (
            <p className="text-sm text-gray-600">
              Seleccionado: <b>{fileSelected.name}</b>
            </p>
          )}
          <button
            onClick={() => handleUpload(slot)}
            className="w-full bg-green-700 hover:bg-green-800 text-white py-2 rounded"
          >
            {content ? "Reemplazar" : "Subir"} contenido
          </button>
        </div>
      </div>
    );
  };

  // Eliminar pregunta con confirmación (sin cambios)
  const handleEliminarPregunta = async (id) => {
    const result = await Swal.fire({
      title: "¿Eliminar pregunta?",
      text: "¡No podrás revertir esto!",
      icon: "warning",
      iconColor: "#fa2a00",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#99a3a4 ",
      confirmButtonText: "Eliminar",
    });
    if (result.isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/api/preguntas/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPreguntas((prev) => prev.filter((p) => p.id !== id));
        Swal.fire("¡Eliminada!", "La pregunta fue eliminada.", "success");
      } catch (err) {
        setError("Error al eliminar la pregunta");
      }
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
      }}
    >
      <HeaderAdmin />

      <div className="bg-white w-full py-2 text-center text-lg font-montserrat font-extrabold">
        Identidad Institucional
      </div>

      <div className="flex-grow flex flex-col sm:flex-row p-4 gap-4">
        {/* Panel lateral */}
        <div className="w-full sm:w-1/4 bg-white rounded-lg p-4 shadow-lg">
          <h2 className="text-xl font-bold mb-4">Opciones</h2>
          <button
            onClick={() => navigate(-1)}
            className="w-full text-left px-4 py-2 bg-gray-100 hover:bg-green-600 hover:text-white rounded transition-colors"
          >
            ← Volver atrás
          </button>
        </div>

        {/* Contenido principal */}
        <div className="w-full sm:w-3/4 bg-white rounded-lg p-6 shadow-lg flex flex-col">
          {/* Cabecera */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
            <div>
              <h2 className="text-2xl font-bold">
                {tema ? tema.nombre : "Cargando tema…"}
              </h2>
            </div>

            <div className="flex gap-2">
              <Link
                to={`/admin/crear-pregunta?tema=${temaId}`}
                className="bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded flex items-center gap-2"
              >
                <span>Nueva pregunta</span>
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </Link>
            </div>
          </div>

          {/* Gestión de contenidos (3 slots) */}
          <div className="mb-8">
            <h3 className="text-xl font-bold mb-3">Contenido multimedia</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[1, 2, 3].map((slot) => (
                <SlotCard key={slot} slot={slot} />
              ))}
            </div>
          </div>

          {/* Listado de preguntas */}
          <div className="flex-grow overflow-y-auto">
            <h3 className="text-xl font-bold mb-4">
              Preguntas ({preguntas.length})
            </h3>

            {preguntas.length > 0 ? (
              <div className="space-y-3">
                {preguntas.map((pregunta) => (
                  <div
                    key={pregunta.id}
                    className="bg-gray-50 p-4 rounded-lg border flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3"
                  >
                    <p className="flex-grow font-medium">
                      {pregunta.texto_pregunta}
                    </p>

                    <div className="flex gap-2">
                      {/* Editar */}
                      <Link
                        to={`/admin/editar-pregunta/${pregunta.id}?tema=${temaId}`}
                        className="bg-green-700 hover:bg-green-700 text-white px-3 py-2 rounded text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-green-500"
                        aria-label="Editar pregunta"
                        title="Editar pregunta"
                      >
                        Editar
                      </Link>

                      {/* Eliminar (ya lo tenías) */}
                      <button
                        onClick={() => handleEliminarPregunta(pregunta.id)}
                        className="bg-red-500 hover:bg-red-600 text-white p-2 rounded flex items-center"
                      >
                        <img src={basura} alt="Eliminar" className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-gray-100 p-8 text-center rounded-lg">
                <p className="text-gray-500">No hay preguntas en este tema</p>
                <Link
                  to={`/admin/crear-pregunta?tema=${temaId}`}
                  className="inline-block mt-4 bg-green-700 hover:bg-green-800 text-white px-4 py-2 rounded"
                >
                  Crear primera pregunta
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mensajes de error */}
      {error && (
        <div className="fixed bottom-0 left-0 right-0 bg-red-500 text-white p-4 text-center">
          {error}
          <button onClick={() => setError("")} className="ml-4">
            ✕
          </button>
        </div>
      )}

      {renderMultimediaModal()}
    </div>
  );
};

export default TemasNivel;
